export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/twitter-icon.5836fefd.svg","height":16,"width":18};